import moment from 'moment';
import PropTypes from 'prop-types';
// @mui
import { TableRow, TableCell } from '@mui/material';
import { analyticsTableFirstCellStyle, analyticsTableRowStyle, centeredText } from '../../../../styles/analytics';

const PractitionerMonthlyTableRow = ({ data }) => (
    <TableRow hover sx={analyticsTableRowStyle}>
        <TableCell sx={analyticsTableFirstCellStyle}>
            {moment(data?.month || 0, 'MM').format('MMM')} {data?.year || 0}
        </TableCell>
        <TableCell sx={centeredText}>
            {data?.data?.CONSULTATION_BOOKED?.count || 0}
        </TableCell>

        <TableCell sx={centeredText}>
            {data?.data?.CONSULTATION_ATTENDED?.count || 0}
        </TableCell>

        <TableCell sx={centeredText}>
            {data?.data?.TREATMENT_STARTED?.count || 0}
        </TableCell>

    </TableRow>
)


PractitionerMonthlyTableRow.propTypes = {
    data: PropTypes.any,
};

export default PractitionerMonthlyTableRow;
